<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch7" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="11" id="pg_11" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch7" id="ch7" title="Link target outside of Sample"><b><i>Looking Back</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">I look back on occasion.</p>
<p class="VSB">It takes only seconds</p>
<p class="VSB">to recall the parts of me</p>
<p class="V">that I’ve had to leave behind. All the</p>
<p class="VSB">dirty fragments</p>
<p class="VSB">I’ve tried to bury will resurrect</p>
<p class="VSB">and reassemble for a glimpse.</p>
<p class="V"><i>I look back</i> because it forces me to remember</p>
<p class="VSB">that I’ve battled as valiantly</p>
<p class="VSB">as any love-starved fool</p>
<p class="V">for the peace I now possess.</p>
<p class="VSB">I can say this now …</p>
<p class="VSB"><i>“You’ll look back one day.</i></p>
<p class="V">You’ll realize all the things you tossed and</p>
<p class="VSB">turned over were not worth</p>
<p class="V">getting into bed with, much less worrying</p>
<p class="V">about.”</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter7.vue?e18cdf72